
import { Component, Input, OnChanges } from '@angular/core';

import _uniqBy from 'lodash-es/uniqBy';

import { Yii } from 'libraries/interfaces/Yii';
import { ILabels } from 'libraries/interfaces/ILabels';
import { ISectorAir, IGetBookingsAirResponse } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { IServicesTableConfig } from '../../shared/components/services-table/IServicesTableConfig';
import { TableServicesService, ITableConfigGetterInput, ITableSectorServices } from '../../shared/services/table-services/table-services.service';

@Component({
    selector: 'sector-air-services',
    template: `

        <services-table *ngIf="isServiceDefined && isTravellerDefined" [tableConfig]="servicesTableConfig"></services-table>

        <notification *ngIf="!isServiceDefined">{{ labels.noService }}</notification>
        <notification *ngIf="!isTravellerDefined">{{ labels.noTraveller }}</notification>
    `,
    styles: [`
        loader ::ng-deep .content-loader{
            padding: .75rem;
        }
    `]
})

export class SectorAirServicesComponent implements OnChanges{

    public labels: ILabels = {
        noService: Yii.t('wui-shared-js', "Aucun service n'est défini sur le dossier aérien"),
        noTraveller: Yii.t('wui-shared-js', "Aucun voyageur pour cette étape"),
        enumOnLoad: Yii.t('wui-shared-js', "Chargement de la configuration des services"),
    };

    public servicesTableConfig: IServicesTableConfig;
    public isServiceDefined: boolean;
    public isTravellerDefined: boolean;

    @Input()
    public sectorData: ISectorAir;

    @Input()
    public bookingData: IGetBookingsAirResponse;

    @Input()
    public tableServices: ITableSectorServices;


    constructor(
        private readonly tableServicesService : TableServicesService,
    ){}

    public ngOnChanges(): void {
        if (this.bookingData){
            this.initServicesTable();
        }
    }

    public initServicesTable(): void {
        this.isData();
        this.servicesTableConfig = this.isServiceDefined ? this.getTableConfig() : null;
    }

    public isData(): void {
        const ssr: number = this.bookingData.ssr ?
            this.bookingData.ssr.length + Object
                .keys(this.tableServices.servicesConfig)
                .filter((configFieldName: string) => this.tableServices.servicesConfig[configFieldName].isRequired).length :
            0;

        this.isServiceDefined = ssr > 0 && this.tableServices.servicesList && this.tableServices.servicesList.length > 0;
        this.isTravellerDefined = this.bookingData.traveller && this.bookingData.traveller.length > 0;
    }

    private getTableConfig(): IServicesTableConfig {

        const tableConfigGetter: ITableConfigGetterInput = {
            ...this.tableServices,
            sectorXId: this.sectorData.xId,
            type: this.sectorData.xType
        };

        return this.tableServicesService.getSectorTableConfig(tableConfigGetter);
    }

}